export const SERVICE_PAGES = {
    main: 'servicemain',
    robot: 'servicerobot',
    wait: 'servicewait',
    complete: 'servicecomplete',
    fail: 'servicefail',
} as const;

export const SERVICE_ROUTES = {
    main: `/:id/${SERVICE_PAGES.main}`,
    robot: `/:id/${SERVICE_PAGES.robot}`,
    wait: `/:id/${SERVICE_PAGES.wait}`,
    complete: `/:id/${SERVICE_PAGES.complete}`,
    fail: `/:id/${SERVICE_PAGES.fail}`,
} as const;

export const SERVICE_API = {
    GET_FILE: '/api/get_file',
    GET_FISC_DATA: '/api/get_fisc_data',
    GET_CHECK: '/api/get_check',
} as const;

export const SERVICE_DEV_API = {
    GET_FILE: '/dev/get_file.json',
    GET_FISC_DATA: '/dev/get_fisc_data.json',
} as const;
